import { css } from 'styled-components';

import {
  darkmodeCssVarDefinitions,
  lightmodeCssVarDefinitions
} from '@/utils/theme/palette/cssVars';

function objToCssString(obj: Record<string, string | number>) {
  return Object.entries(obj)
    .map(([key, val]) => `${key}: ${val};`)
    .join('\n');
}

export const colorThemeVars = css`
  :root {
    ${objToCssString(darkmodeCssVarDefinitions)}
  }

  [data-theme='light'] {
    ${objToCssString(lightmodeCssVarDefinitions)}
  }
`;
